<template>
  <el-select class="select-default"
             v-bind="$attrs"
             v-on="$listeners">
    <el-option v-for="option in options"
               :key="option.lable"
               v-bind="option"
               class="select-default"/>
  </el-select>
</template>
<script>
  import { Select, Option } from 'element-ui'

  export default {
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    computed: {
      options() {
        return [
          {
            label: this.$t('salaryTypes.year'),
            value: 'year'
          },
          {
            label: this.$t('salaryTypes.month'),
            value: 'month'
          },
          {
            label: this.$t('salaryTypes.day'),
            value: 'day'
          },
          {
            label: this.$t('salaryTypes.hour'),
            value: 'hour'
          },
          {
            label: this.$t('salaryTypes.project'),
            value: 'project'
          }
        ]
      }
    }
  }
</script>
<style>
</style>
